export const adaptLumenes = (lumenes) => {
    return {
        id: lumenes?.idLumenes,
        displayName: lumenes?.nombre
    }
}

export const adaptLumenesArray = (
    Lumenes
) => {
    return structuredClone(Lumenes?.allLumenes)
        ?.map(lumen => adaptLumenes(lumen));
}